import React, { useCallback, useEffect, useState } from 'react';
import cx from 'classnames';

import Button from '../../../Buttons/Button';
import { useRefValue } from '../../../../hooks';
import { format, differenceInDays } from '../../../../utils/date';

const emptyArray = [];

const useZoomButtons = ({
  chartRef,
  initialExtremes = emptyArray,
  resetRangeFlag = emptyArray,
  className = 'zoom-btn-abs',
  style,
  handleApplyClick,
}) => {
  const [showServiceButtons, setShowServiceButtons] = useState(false);
  const initialExtremesRef = useRefValue(initialExtremes);

  const resetRange = useCallback(() => {
    if (chartRef.current?.chartAPIRef()) {
      chartRef.current.chartAPIRef().xAxis[0].setExtremes(...initialExtremesRef.current);
    }
  }, []);

  useEffect(() => {
    if (resetRangeFlag.length) {
      resetRange();
    }
  }, [...resetRangeFlag]);

  const applyRange = () => {
    if (chartRef.current && chartRef.current.chartAPIRef()) {
      const { min: from, max: to } = chartRef.current.chartAPIRef().xAxis[0];
      const detail = {
        period: differenceInDays(to, from),
        period_from_date: format(from),
        period_to_date: format(to),
      };

      handleApplyClick(detail);
      setShowServiceButtons(false);
    }
  };

  const ZoomButtons = showServiceButtons ? (
    <div className={cx('zoom-buttons', className)} style={style}>
      <Button className="reset-button" onClick={resetRange}>
        Reset
      </Button>
      {handleApplyClick && (
        <Button className="apply-button" onClick={applyRange}>
          Apply Range to Page
        </Button>
      )}
    </div>
  ) : null;

  return [ZoomButtons, setShowServiceButtons];
};
export default useZoomButtons;
